import React, { useEffect, useReducer, useCallback, useMemo } from "react";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import { getNotes } from "./service";
import Html from "./html";
import EditNote from "./components/editNote";

const EachFtmNotes = ({ ftm_id, open, handleClose }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    const fetchData = useCallback(async () => {
        if (ftm_id) {
            getNotes(ftm_id, dispatch);
        }
    }, [ftm_id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Memoize context value to prevent unnecessary re-renders
    const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

    return (
        <Context.Provider value={contextValue}>
            <Html
                ftm_id={ftm_id}
                open={open}
                handleClose={handleClose}
                onRefreshData={fetchData}
            />
            <EditNote />
        </Context.Provider>
    );
}

export default EachFtmNotes;